import { render, staticRenderFns } from "./Astroid.vue?vue&type=template&id=448ae862&scoped=true&"
import script from "./Astroid.vue?vue&type=script&lang=js&"
export * from "./Astroid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ae862",
  null
  
)

export default component.exports